import React, {
  ReactElement,
  LazyExoticComponent,
  Suspense,
  useMemo,
} from 'react';
import { APP, PAGE_NAMES } from 'appenv';
import Routes from 'Routes';
import styled from 'styled-components';
import { Booth } from 'models/exhibitors';
import Footer from 'components/footer/Footer';
import XtraBreadcrumbs from 'components/XtraBreadcrumbs';
import { useTranslation } from 'react-i18next';
import BoothPreview from './BoothPreview';
import BreadcrumbsNoFilterContainer from './BreadcrumbsNoFilterContainer';

const IEBreadcrumbsNoFilterContainer = styled(BreadcrumbsNoFilterContainer)`
  flex-basis: 100%;
`;

const IEBoothListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

let HallPageHeader: LazyExoticComponent<() => ReactElement> | (() => ReactElement) = () => <div />;
if (APP === 'polyu618') {
  HallPageHeader = React.lazy(() => import('./PolyU618Header'));
}

const hideBreadcrumbsList = ['scmp711'];

const InvisibleSeparator = styled.div`
  flex-basis: 100%;
  height: 0;
`;

const MainContainer = styled.div`
  min-height: 100%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const IEBoothList = ({
  exhibitors = [],
  isDesktop,
  hasFilter,
}: {
  isDesktop: boolean;
  exhibitors: Booth[];
  hasFilter: boolean;
}) => {
  const { t } = useTranslation();
  const upgradedExhibitors = useMemo(() => exhibitors.filter((booth) => booth?.type === 'u'), [exhibitors]);
  const basicExhibitors = useMemo(() => exhibitors.filter((booth) => booth?.type !== 'u'), [exhibitors]);

  return (
    <MainContainer>
      <IEBoothListContainer>
        {!(hasFilter && isDesktop) && !hideBreadcrumbsList.includes(APP) && (
        <IEBreadcrumbsNoFilterContainer>
          <XtraBreadcrumbs paths={[{ name: PAGE_NAMES.lobby || t('page.lobby', 'Lobby'), to: Routes.lobby }, { name: PAGE_NAMES.hall }]} />
        </IEBreadcrumbsNoFilterContainer>
        )}
        <Suspense fallback={null}>
          <HallPageHeader />
        </Suspense>
        {upgradedExhibitors.map((booth, index) => (
          <BoothPreview
            booth={booth}
            index={index}
          />
        ))}
        <InvisibleSeparator />
        {basicExhibitors.map((booth, index) => (
          <BoothPreview
            booth={booth}
            index={index}
          />
        ))}
      </IEBoothListContainer>
      <Footer hashState="/hall" />
    </MainContainer>
  );
};

export default IEBoothList;
